import React from 'react';
export function Footer() {
  return <footer className="bg-forest-900 border-t-4 border-gold py-10 px-4 text-center" data-id="element-134" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-135" data-mp="3gg0zo4mhnzy6">
        Educational reference and awareness material only. Workplace safety instruction, practical
        assessments and equipment-related tasks must follow applicable regulations, employer procedures
        and manufacturer instructions.
      </p>
      <p className="text-sm text-white/80" data-id="element-136" data-mp="3ud7h9vvh7slt">© Workplace Safety Atlas 2026 — All Rights Reserved.</p>
    </footer>;
}